import PropTypes from "prop-types"
import React from "react"
import { Visibility, Image, Loader, ImageProps } from "semantic-ui-react"
import { stringify } from "../../utils/stringifyier"

const LazyImage = (props: ImageProps) => {
  const { src, ...remaining } = props
  const [loading, setLoading] = React.useState(true)
  const [img, setImg] = React.useState("")
  const [controller, setController] = React.useState<
    AbortController | undefined
  >(undefined)

  React.useEffect(() => {
    controller?.abort()
    const c = new AbortController()
    setLoading(true)
    fetch(src, { signal: c.signal, cache: "force-cache" })
      .then((res) => res.blob())
      .then((imageBlob) => {
        const imageObjectURL = URL.createObjectURL(imageBlob)
        setImg(imageObjectURL)
        setLoading(false)
      })
      .catch(() => {
        setLoading(true)
      })
    setController(c)
  }, [src])

  React.useEffect(() => {
    return () => {
      controller?.abort()
    }
  }, [controller])

  return (
    <div
      style={{
        position: "relative",
        width: "100%",
        height: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      {(loading && (
        <div
          style={{
            position: "absolute",
            width: "100%",
            height: "100%",
            backgroundColor: "white",
          }}
        >
          <Loader active inline="centered" size={props.size} />
        </div>
      )) || <img {...remaining} alt={"Error"} src={img} />}
    </div>
  )
}

export default LazyImage
